import { Box, Typography } from "@mui/material";
import l10n from "../../lib/l10n"
import { useAppDrawer } from "../../store/app-drawer";
import FormFactory from "../FormFactory";

function CheckoutQuoteForm({ resolve, reject }) {
  const { closeDrawer } = useAppDrawer();
  return (
    <>
      <Box component="header" p={2}>
        <Typography variant={'h5'}>Richiedi informazioni</Typography>
        <Typography>
          Compila il modulo qui sotto, verrai ricontattato da un nostro esperto che ti fornirà le informazioni riguardanti questo prodotto.
        </Typography>
      </Box>
      <FormFactory
        onSubmit={(form, formObject) => {
          resolve(formObject);
          closeDrawer();
        }}
        fields={l10n.ui_quote_formfields}
        terms={l10n.ui_quote_terms}
      />
    </>
  )
};

export default CheckoutQuoteForm;